<template>
	<fieldset class="icg-calc__total">
		<legend>Total</legend>
		<div class="icg-calc__form-wrap">
			<div>
				<label>Before Taxes, Shipping, and Coupons</label>
				<span class="icg-calc__total-amount">{{ grandTotal }}</span>
			</div>
		</div>
		<div class="icg-calc__button-wrap">
			<input type="hidden" name="calculator" :value="store.calculator" />
			<input type="hidden" name="unit_price" :value="this.unitPrice" />
			<input type="hidden" name="unit_weight" :value="this.unitWeight" />
			<input type="hidden" name="page_width" :value="store.paperWidth" />
			<input
				type="hidden"
				name="page_length"
				:value="store.paperLength"
			/>
			<button
				:disabled="isButtonDisabled"
				:value="store.productId"
				class="icg-calc__submit-btn single_add_to_cart_button button alt sc_button_hover_slide_left sc_button_hover_style_hover"
				name="add-to-cart"
				type="submit"
			>
				Add to cart &amp; upload files
			</button>
		</div>
	</fieldset>
</template>

<script>
import { store } from "../store";

export default {
	data() {
		return {
			store: store
		};
	},

	computed: {
		addonCost() {
			return (
				(Number(store.bindingCharge) +
					Number(store.coatingCharge) +
					Number(store.foldingCharge)) *
				store.qty
				// store.qty +
				// (store.productionCost + store.bleedCost + this.finishingCost) *
				// 	this.printingCost
			);
		},

		coverCost() {
			return (
				(Number(store.coverPaperCharge) +
					Number(store.coverInkCharge)) *
				store.qty *
				store.costFactor *
				store.sizeFactor *
				store.landscapePremium
			);
		},

		finishingCost() {
			return (
				(store.shrinkWrapCharge +
					store.drillingCharge +
					store.cornerRoundingCharge +
					store.coverFrontCharge +
					store.coverBackCharge +
					store.coilPlasticColorCharge +
					store.coilWireoColorCharge) *
				store.qty
			);
		},

		grandTotal() {
			return (
				Number(this.printingCost) +
				Number(this.addonCost) +
				Number(store.proofCharge)
			).toLocaleString("en-US", { style: "currency", currency: "USD" });
		},

		insidePageCost() {
			return (
				(Number(store.paperCharge) + Number(store.clickCharge)) *
					store.pages *
					store.qty *
					store.costFactor *
					store.sizeFactor *
					store.landscapePremium *
					this.pageDiscount +
				this.setupCost
			);
		},

		isButtonDisabled() {
			return store.totalRequiredFields > store.totalCompletedFields;
		},

		pageDiscount() {
			return 1 - store.pageDiscount / 100;
		},

		printingCost() {
			if (store.calculator === "multi_page") {
				return (
					(Number(this.insidePageCost) + Number(this.coverCost)) *
						store.productionCost +
					this.finishingCost
				);
			} else {
				return (
					(Number(store.costFactor) +
						Number(store.paperCharge) +
						Number(store.clickCharge)) *
						store.qty *
						store.padding *
						store.sizeFactor *
						store.bleedCost *
						store.productionCost +
					store.qty * store.blankEnvelopeCharge +
					store.qty * store.cornerRoundingCharge
				);
			}
		},

		setupCost() {
			let setupCost = 0;

			store.setupCosts.forEach(costRange => {
				if (store.qty >= costRange.min && store.qty <= costRange.max) {
					setupCost = costRange.cost;
				}
			});

			return setupCost;
		},

		unitPrice() {
			return (
				(Number(this.printingCost) +
					Number(this.addonCost) +
					Number(store.proofCharge)) /
				store.qty
			).toFixed(4);
		},

		unitWeight() {
			let weightPerSheet =
				(store.sizeSquareInches / store.standardSheetSize) *
				store.paperWeight;

			if (store.calculator === "multi_page") {
				let coverPaperWeight =
					(store.sizeSquareInches / store.standardSheetSize) *
					store.coverPaperWeight;
				return (
					(weightPerSheet * store.qty * store.pages +
						Number(coverPaperWeight)) /
					store.qty
				).toFixed(4);
			} else {
				return weightPerSheet.toFixed(4);
			}
		}
	}
};
</script>
